<template>
    <div>
        <div class="form-container">
            <div class="form-title margin-b20">表1-基本资质审查</div>
            <div class="flex margin-b10">
                <UploadGetData
                        :limit="1"
                        :fileSize="2"
                        :uploadUrl="basicQualificationImport"
                        :verify="true"
                        @getFileInfo="getTableFourInfo"
                        :isOnlyXlsx="true"
                />
                <eui-btn type="weak"  width="88" v-debounce="basicQualificationsDown">下载模板</eui-btn>
<!--                <eui-btn type="weak" width="60">导入</eui-btn>-->
<!--                <eui-btn type="weak" width="88">下载模板</eui-btn>-->
            </div>
            <div class="table-wrapper">
                <!--表头-->
                <div class="common-box table-title">
                    <div class="first-item border-right-item">评审项目</div>
                    <div class="second-item border-right-item">评审内容</div>
                    <div class="third-item border-right-item">合格条件</div>
                    <div class="four-item border-right-item">备注</div>
                    <div class="five-item">操作</div>
                </div>
                <!--生产商-->
                <div v-if="supplierType === '101'">
                    <!--表格 第一行内容-->
                    <div class="common-box table-content-height table-content">
                        <div class="first-item border-right-item">{{basicQualifications.auditItem}}</div>
                        <div class="second-item border-right-item">
                            <e-tooltip :content="basicQualifications.auditContent" :set-length="18"/>
                        </div>
                        <div class="third-item border-right-item">
                            <e-tooltip :content="basicQualifications.eligibility" :set-length="18"/>
                        </div>
                        <div class="four-item border-right-item">
                            <el-input v-model="basicQualifications.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                        </div>
                        <div class="five-item"></div>
                    </div>
                    <!--表格 第二行内容-->
                    <div class="handle-box">
                        <div class="handle-left">生产经营资质</div>
                        <div class="handle-right">
                            <div v-for="(item,index) in qualificationsData" :key="index">
                                <div class="right-top">
                                    <div class="handle-second">
                                        <div class="second-left">
                                            <el-input v-model="item.auditContent" placeholder="请输入评审内容"
                                                      style="padding: 10px"></el-input>
                                        </div>
                                        <div class="second-right">
                                            <el-checkbox v-model="item.required">必传项</el-checkbox>
                                        </div>
                                    </div>
                                    <div class="handle-third">
                                        <el-input v-model="item.eligibility" placeholder="请输入合格条件" style="padding: 10px"></el-input>
                                    </div>
                                    <div class="handle-four">
                                        <el-input v-model="item.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                                    </div>
                                    <div class="handle-five del-box" @click="delQualifications(index)"
                                         :style="{ color: qualificationsData.length === 1 ? '#999' : '#0064C8' }">删除
                                    </div>
                                </div>
                            </div>
                            <div class="right-bottom">
                                <div class="table-add" @click="addQualifications">
                                    <eui-icon class="data-icon" icon="eicon-add"/>
                                    新增生产经营资质
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--表格 第三行内容-->
                    <div class="common-box table-content-height table-content">
                        <div class="first-item border-right-item">{{integritySituation.auditItem}}</div>
                        <div class="second-item border-right-item">
                            <e-tooltip :content="integritySituation.auditContent" :set-length="18"/>
                        </div>
                        <div class="third-item border-right-item">
                            <e-tooltip :content="integritySituation.eligibility" :set-length="18"/>
                        </div>
                        <div class="four-item border-right-item">
                            <el-input v-model="integritySituation.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                        </div>
                        <div class="five-item"></div>
                    </div>
                </div>
                <!--流通商-->
                <div v-if="supplierType === '103'">
                    <!--流通商 第一行-->
                    <div class="handle-box">
                        <div class="handle-left">基本资质</div>
                        <div class="handle-right">
                            <div v-for="(item,index) in ltsBasicQualifications" :key="index">
                                <div class="right-top" :style="{ 'border-bottom': index === ltsBasicQualifications.length -1 ? 'none' : '1px solid #DCDCDC' }">
                                    <div class="handle-second">
                                        <div class="second-left">{{item.auditContent}}</div>
                                    </div>
                                    <div class="handle-third flex-all-center">  <e-tooltip :content="item.eligibility" :set-length="18"/></div>
                                    <div class="handle-four">
                                        <el-input v-model="item.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                                    </div>
                                    <div class="handle-five del-box">
                                         <el-checkbox v-model="item.required" :disabled="index === 0"></el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--流通商 第二行-->
                    <div class="handle-box">
                        <div class="handle-left">诚信情况</div>
                        <div class="handle-right">
                            <div v-for="(item,index) in ltsIntegritySituation" :key="index" >
                                <div class="right-top" :style="{ 'border-bottom': index === ltsIntegritySituation.length -1 ? 'none' : '1px solid #DCDCDC' }">
                                    <div class="handle-second">
                                        <div class="second-left">
                                            <e-tooltip :content="item.auditContent" :set-length="18"/>
                                        </div>
                                    </div>
                                    <div class="handle-third flex-all-center">
                                        <e-tooltip :content="item.eligibility" :set-length="18"/>
                                    </div>
                                    <div class="handle-four">
                                        <el-input v-model="item.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                                    </div>
                                    <div class="handle-five del-box">
                                            <el-checkbox v-model="item.required" :disabled="index === 1"></el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!--生产商 表格 第四行内容；流通商是 第三行-->
                <div class="handle-box" style="border-bottom: 1px solid #DCDCDC">
                    <div class="handle-left">
                        <div>其他</div>
                        <div>(非必填)</div>
                    </div>
                    <div class="handle-right">
                        <div v-for="(item,index) in otherData" :key="index">
                            <div class="right-top">
                                <div class="handle-second">
                                    <div class="second-left">
                                        <el-input v-model="item.auditContent" placeholder="请输入评审内容"
                                                  style="padding: 10px"></el-input>
                                    </div>
                                </div>
                                <div class="handle-third">
                                    <el-input v-model="item.eligibility" placeholder="请输入合格条件" style="padding: 10px"></el-input>
                                </div>
                                <div class="handle-four">
                                    <el-input v-model="item.remark" placeholder="请输入备注" style="padding: 10px"></el-input>
                                </div>
                                <div class="handle-five del-box" @click="delOther(index)"
                                     :style="{ color: otherData.length === 1 ? '#999' : '#0064C8' }">删除
                                </div>
                            </div>
                        </div>
                        <div class="right-bottom">
                            <div class="table-add" @click="addOther">
                                <eui-icon class="data-icon" icon="eicon-add"/>
                                新增其他
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-sb">
            <div>
                <eui-btn type="weak" @click="backStep">上一步</eui-btn>
            </div>
            <div>
                <eui-btn type="weak" style="margin-right: 30px" v-debounce="() =>tempSaveOrConfirmNext(0)">保 存</eui-btn>
                <eui-btn type="primary" v-debounce="() =>tempSaveOrConfirmNext(1)">下一步</eui-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/modules/projectA/api/ESorganization/index';
    import UploadGetData from './uploadGetData.vue';
    import utils from '@/modules/projectA/utils/utils';
    import eTooltip from "../../../../components/common/e-tooltip";
    export default {
        name: "basicQualificationReview",
        components:{UploadGetData,eTooltip},
        props: {
            supplierType: {
                type: String,
                default: ''
            },
            evaluationId: {
                type: Number,
                default: 1687
            }
        },
        data() {
            return {
                basicQualificationImport:'',
                baseDataInfo: {},
                evaluationBasicQualificationList: [],
                //流通商 基本资质
                ltsBasicQualifications: [
                    {
                        auditItem: '基本资质',
                        auditContent: '营业执照',
                        auditContentCode: '',
                        eligibility: '应为独立法人或其他组织，并具备有效执照，执照在有效期内，经营范围包含被评价产品品种',
                        remark: '',
                        required: true,
                        sortNum: 1
                    },
                    {
                        auditItem: '基本资质',
                        auditContent: '土地、房屋有效文件',
                        auditContentCode: '',
                        eligibility: '有土地证、产权证、场地租赁等有效证明文件',
                        remark: '',
                        required: false,
                        sortNum: 2
                    },
                    {
                        auditItem: '基本资质',
                        auditContent: '代理商应有代理协议或授权文件',
                        auditContentCode: '',
                        eligibility: '代理协议或授权文件在有效期内，且范围包含被评价产品品种',
                        remark: '',
                        required: false,
                        sortNum: 3
                    },
                ],
                //流通商 的 诚信情况
                ltsIntegritySituation:[
                    {
                        auditItem: '诚信情况',
                        auditContent: '所销售产品近三年内未出现重要的投诉或出现明显质量问题，在近一年内国家或行业监督抽查未出现不合格现象。近三年内未出现重大经营管理风险和法律纠纷',
                        auditContentCode: '',
                        eligibility: '提供企业信息公示系统查询结果，或采信法人信用认证结果',
                        remark: '',
                        required: false,
                        sortNum: 4
                    },
                    {
                        auditItem: '诚信情况',
                        auditContent: '对所提供资料真实性负责',
                        auditContentCode: '',
                        eligibility: '企业承诺所提供的相关资料真实有效',
                        remark: '',
                        required: true,
                        sortNum: 5
                    },
                ],
                //第一行 基本资质 数据
                basicQualifications: {
                    auditItem:'基本资质',
                    auditContent:'营业执照',
                    auditContentCode:'',
                    eligibility:'合格条件',
                    remark:'',
                    required :1,
                    sortNum :1
                },
                //第二行生产经营资质
                qualificationsData: [
                ],
                //第三行 诚信情况
                integritySituation: {
                    auditItem:'诚信情况',
                    auditContent:'对所提供样品及相关资料真实性负责',
                    auditContentCode:'',
                    eligibility:'生产企业承诺所提供样品及相关资料真实有效',
                    remark:'',
                    required :1,
                    sortNum :1
                },
                //第四行 其他非必填  数据
                otherData: [
                ],
                checked: false,
                input: '',
                //用于初始化 第二行 第四行数据
                emptyObject:    {
                    auditContent: '',
                    auditContentCode: '',  //不是必填，手输就没有
                    auditItem: '',
                    eligibility: '',
                    remark: '',
                    required: false,
                    sortNum: 1
                },
            }
        },
        methods: {
            //基本资质审查 导入
            getTableFourInfo(info, index){
                this.evaluationBasicQualificationList = info || [];
                this.initalData();
            },
            async basicQualificationsDown(){
                const result = await api.basicQualificationsDown();
                if (result.type == 'application/json') {
                    utils.fileExportResponseError(result);
                } else {
                    utils.downFile(result, '基本资质审查表','.xls');
                }
            },
            //流通商 处理 数据的评级
            ltsDealData(){
                let combineArr = this.ltsBasicQualifications.concat(this.ltsIntegritySituation);

                let lastSortNum = 5;
                //其他 数据的 处理
                if(this.otherData.length > 0 && this.otherData[0].auditContent){
                    this.otherData.forEach(item=>{
                        combineArr.push({...item,sortNum:Number(lastSortNum)+1})
                    })
                }

                return combineArr;
            },
            //生产商  处理四行数据为平级 sortNum 依次累加
            dealData(){
                let evaluationBasicQualificationList = [];
                //第一行数据的平级
                evaluationBasicQualificationList.push({...this.basicQualifications,sortNum:1});
                //第二行数据的平级
                this.qualificationsData.forEach((item,index)=>{
                    evaluationBasicQualificationList.push({...item,sortNum:Number(index)+2})
                })
                //处理第三行数据的平级
                evaluationBasicQualificationList.push({...this.integritySituation,sortNum:evaluationBasicQualificationList.length + 1});
                //获取 添加第三行数据后 的 sortNum 方便计算第四行
                let lastSortNum = evaluationBasicQualificationList[evaluationBasicQualificationList.length-1].sortNum;
                //处理第四行数据的平级
                if(this.otherData.length > 0 && this.otherData[0].auditContent){
                    this.otherData.forEach(item=>{
                        evaluationBasicQualificationList.push({...item,sortNum:Number(lastSortNum)+1})
                    })
                }
              return evaluationBasicQualificationList;
            },
            //上一步
            backStep(){
                this.$emit('getStep', 1);
            },
            //各种输入的校验
            testInput(){
                let messageTip = '';
                if(this.supplierType === '101'){
                    //生产经营资质 的 校验
                    this.qualificationsData.forEach(item=>{
                        if (!item.eligibility) {
                            messageTip = item.auditItem+'的合格条件不能为空。';
                        }
                        if (!item.auditContent) {
                            messageTip = item.auditItem+'的评审内容不能为空。';
                        }
                    });

                    if(messageTip){
                        this.$message.warning(messageTip);
                        return messageTip;
                    }
                }

                //其他数据的校验
                this.otherData.forEach(item=>{
                    if (!item.eligibility && item.auditContent) {
                        messageTip = item.auditItem+'的合格条件不能为空。';
                    }
                    if (item.eligibility && !item.auditContent ) {
                        messageTip = item.auditItem+'的评审内容不能为空。';
                    }
                })

                if(messageTip){
                    this.$message.warning(messageTip);
                    return messageTip;
                }
                return false;
            },
            //0 是 保存，1 是 下一步
            async tempSaveOrConfirmNext(tempSaveOrConfirmNext) {
                if(tempSaveOrConfirmNext && this.testInput()){
                    return false;
                }
                let evaluationBasicQualificationList = [];
                if(this.supplierType === '101'){
                     evaluationBasicQualificationList =   this.dealData(); //生产商 处理四行数据为平级
                }else{
                     evaluationBasicQualificationList =   this.ltsDealData(); //流通商 处理数据为平级
                }

                evaluationBasicQualificationList.forEach(item=>{
                    item.required = item.required ? 1 : 0;
                })

                
                let params = {
                    tempSaveOrConfirmNext: tempSaveOrConfirmNext,
                    currentStep: 2,
                    evaluationCode: this.baseDataInfo.evaluationCode,
                    evaluationId: this.baseDataInfo.evaluationId,
                    evaluationBasicQualificationList: evaluationBasicQualificationList,
                }

                let res = await api.tempSaveOrConfirmNext(params);
                if (res.success) {
                    if (tempSaveOrConfirmNext === 1) {
                        this.$emit('getStep', 3);
                    } else {
                        this.$message.success('保存成功。')
                    }
                }
            },
            delQualifications(index) {
                if (this.qualificationsData.length === 1) {
                    return false;
                }
                this.qualificationsData.splice(index, 1)
            },
            delOther(index) {
                if (this.otherData.length === 1) {
                    return false;
                }
                this.otherData.splice(index, 1)
            },
            addQualifications() {
                this.qualificationsData.push({...this.emptyObject,auditItem:'生产经营资质'});
            },
            addOther() {
                this.otherData.push({...this.emptyObject,auditItem:'其他'});
            },
            async auxiliaryStepDetail() {
                let params = {
                    currentStep: 2,
                    evaluationId: this.evaluationId,
                };
                let res = await api.auxiliaryStepDetail(params);
                if (res.success) {
                    this.baseDataInfo = res.data;
                    this.evaluationBasicQualificationList = res.data.evaluationBasicQualificationList || [];
                    this.initalData();
                }
            },

            //数据 的 初始化
            initalData(){
                this.basicQualifications = {};
                this.qualificationsData = [];
                this.integritySituation = {};
                this.otherData = [];

                this.evaluationBasicQualificationList.forEach(item=>{

                    this.$set(item,'required',item.required ? true : false);

                    //第一行
                    if(item.auditItem === '基本资质'){
                        this.basicQualifications = item;
                    }
                    //第二行
                    if(item.auditItem === '生产经营资质'){
                        this.qualificationsData.push(item);
                    }
                    //第三行
                    if(item.auditItem === '诚信情况'){
                        this.integritySituation = item;
                    }
                    //第四行
                    if(item.auditItem === '其他'){
                        this.otherData.push(item);
                    }
                })

                if( this.evaluationBasicQualificationList.length === 0){
                    this.basicQualifications = item;//第一行
                    this.integritySituation = item;//第三行
                }

                //第二行数据 最开始填入 默认 有一行数据
                if(this.qualificationsData.length === 0){
                    this.qualificationsData.push({...this.emptyObject,auditItem:'生产经营资质'})
                }
                //第四行数据 最开始填入 默认 有一行数据
                if(this.otherData.length === 0){
                    this.otherData.push({...this.emptyObject,auditItem:'其他'})
                }
            },
        },
        mounted() {
            this.auxiliaryStepDetail();
            this.basicQualificationImport = api.basicQualificationImport();
        }
    }
</script>

<style scoped lang="scss">
    .table-wrapper {
        .common-box {
            display: flex;
            text-align: center;
            align-items: center;
            font-size: 12px;
            border: 1px solid #DCDCDC;

            .border-right-item {
                height: calc(100% - 1px);
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #DCDCDC;
            }

            .first-item {
                width: 100px;
            }

            .second-item {
                flex: 1;
            }

            .third-item {
                flex: 1;
            }

            .four-item {
                flex: 1;
            }

            .five-item {
                width: 62px;
            }
        }

        .table-title {
            height: 40px;
            background-color: #F5F5F5;
            border-bottom: none;
            color: #333;
        }

        .table-content-height {
            height: 50px;
        }

        .table-content {
            border-bottom: none;
            color: #333;
        }

        .border-b {
            border-bottom: 1px solid #DCDCDC;
        }

        .handle-box {
            display: flex;
            text-align: center;
            align-items: center;
            font-size: 12px;
            border: 1px solid #DCDCDC;
            border-bottom: none;



            .handle-left {
                width: 99px;
            }
            .lts-line{
                border-top: none;
            }
            .handle-right {
                width: calc(100% - 100px);
                border-left: 1px solid #DCDCDC;


                .right-top {
                    display: flex;
                    height: 50px;
                    border-bottom: 1px solid #DCDCDC;

                    .handle-second {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        .second-left {
                            flex: 2;
                        }

                        .second-right {
                            flex: 1;
                        }
                    }

                    .handle-third {
                        flex: 1;
                        border-left: 1px solid #DCDCDC;
                    }

                    .handle-four {
                        flex: 1;
                        border-left: 1px solid #DCDCDC;
                    }

                    .handle-five {
                        width: 62px;
                        line-height: 50px;
                        border-left: 1px solid #DCDCDC;
                    }

                    .del-box {
                        color: #0064C8;
                        cursor: pointer;
                        font-size: 12px;
                    }
                }

                .right-bottom {
                    height: 60px;
                    padding: 10px;
                    background-color: #F5F5F5;

                    .data-icon {
                        width: 10px;
                        height: 10px;
                        margin-right: 10px;
                    }

                    .table-add {
                        font-size: 16px;
                        cursor: pointer;
                        background-color: #fff;
                        height: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #333;
                    }
                }
            }
        }
    }
</style>